export const FETCH_CUSTOMER_DETAIL_REQUESTED = 'FETCH_CUSTOMER_DETAIL_REQUESTED';
export const FETCH_CUSTOMER_DETAIL_SUCCEEDED = 'FETCH_CUSTOMER_DETAIL_SUCCEEDED';
export const FETCH_CUSTOMER_PAYMENT_DETAIL_REQUESTED = 'FETCH_CUSTOMER_PAYMENT_DETAIL_REQUESTED';
export const FETCH_CUSTOMER_PAYMENT_DETAIL_SUCCEEDED = 'FETCH_CUSTOMER_PAYMENT_DETAIL_SUCCEEDED';
export const CREATE_CUSTOMER_ADDRESS_REQUESTED = 'CREATE_CUSTOMER_ADDRESS_REQUESTED';
export const CREATE_CUSTOMER_ADDRESS_SUCCEEDED = 'CREATE_CUSTOMER_ADDRESS_SUCCEEDED';
export const UPDATE_CUSTOMER_REQUESTED = 'UPDATE_CUSTOMER_REQUESTED';
export const UPDATE_CUSTOMER_SUCCEEDED = 'UPDATE_CUSTOMER_SUCCEEDED';
export const UPDATE_CUSTOMER_PAYMENT_DETAIL_REQUESTED = 'UPDATE_CUSTOMER_PAYMENT_DETAIL_REQUESTED';
export const UPDATE_CUSTOMER_PAYMENT_DETAIL_SUCCEEDED = 'UPDATE_CUSTOMER_PAYMENT_DETAIL_SUCCEEDED';
export const FETCH_CUSTOMER_ADDRESSES_REQUESTED = 'FETCH_CUSTOMER_ADDRESSES_REQUESTED';
export const FETCH_CUSTOMER_ADDRESSES_SUCCEEDED = 'FETCH_CUSTOMER_ADDRESSES_SUCCEEDED';
export const DELETE_CUSTOMER_ADDRESS_REQUESTED = 'DELETE_CUSTOMER_ADDRESS_REQUESTED';
export const DELETE_CUSTOMER_ADDRESS_SUCCEEDED = 'DELETE_CUSTOMER_ADDRESS_SUCCEEDED';
export const UPDATE_CUSTOMER_ADDRESS_REQUESTED = 'UPDATE_CUSTOMER_ADDRESS_REQUESTED';
export const UPDATE_CUSTOMER_ADDRESS_SUCCEEDED = 'UPDATE_CUSTOMER_ADDRESS_SUCCEEDED';
export const SET_DEFAULT_ADDRESS_REQUESTED = 'SET_DEFAULT_ADDRESS_REQUESTED';
export const SET_DEFAULT_ADDRESS_SUCCEEDED = 'SET_DEFAULT_ADDRESS_SUCCEEDED';
export const DELETE_CUSTOMER_REQUESTED = 'DELETE_CUSTOMER_REQUESTED';
export const DELETE_CUSTOMER_SUCCEEDED = 'DELETE_CUSTOMER_SUCCEEDED';
export const FETCH_ALL_CUSTOMER_ORDER_SUCCEEDED = 'FETCH_ALL_CUSTOMER_ORDER_SUCCEEDED';
export const FETCH_SELLER_PRODUCTS_REQUESTED = 'FETCH_SELLER_PRODUCTS_REQUESTED';
export const FETCH_SELLER_PRODUCTS_SUCCESSED = 'FETCH_SELLER_PRODUCTS_SUCCESSED';
export const FETCH_USER_WISHLIST_REQUESTED = 'FETCH_USER_WISHLIST_REQUESTED';
export const FETCH_USER_WISHLIST_SUCCESSED = 'FETCH_USER_WISHLIST_SUCCESSED';
export const FETCH_WISHLIST_DETAIL_REQUESTED = 'FETCH_WISHLIST_DETAIL_REQUESTED';
export const FETCH_WISHLIST_DETAIL_SUCCESSED = 'FETCH_WISHLIST_DETAIL_SUCCESSED';
export const FETCH_ALL_PRODUCTS_REQUESTED = 'FETCH_ALL_PRODUCTS_REQUESTED';
export const FETCH_ALL_PRODUCTS_SUCCESSED = 'FETCH_ALL_PRODUCTS_SUCCESSED';
export const CREATE_WISHLIST_REQUESTED = 'CREATE_WISHLIST_REQUESTED';
export const CREATE_WISHLIST_SUCCESSED = 'CREATE_WISHLIST_SUCCESSED';
export const REMOVE_PRODUCT_FROM_WISHLIST_REQUESTED = 'REMOVE_PRODUCT_FROM_WISHLIST_REQUESTED';
export const REMOVE_PRODUCT_FROM_WISHLIST_SUCCESSED = 'REMOVE_PRODUCT_FROM_WISHLIST_SUCCESSED';
export const UPDATED_WISHLIST_REQUESTED = 'UPDATED_WISHLIST_REQUESTED';
export const UPDATED_WISHLIST_SUCCESSED = 'UPDATED_WISHLIST_SUCCESSED';
export const FETCH_USER_CHECKOUT_REQUESTED = 'FETCH_USER_CHECKOUT_REQUESTED';
export const FETCH_USER_CHECKOUT_SUCCEEDED = 'FETCH_USER_CHECKOUT_SUCCEEDED';
export const FETCH_USER_WALLET_REQUESTED = 'FETCH_USER_WALLET_REQUESTED';
export const FETCH_USER_WALLET_SUCCEEDED = 'FETCH_USER_WALLET_SUCCEEDED';
export const CREDIT_WALLET_REQUESTED = 'CREDIT_WALLET_REQUESTED';
export const CREDIT_WALLET_SUCCEEDED = 'CREDIT_WALLET_SUCCEEDED';
export const DEBIT_WALLET_REQUESTED = 'DEBIT_WALLET_REQUESTED';
export const DEBIT_WALLET_SUCCEEDED = 'DEBIT_WALLET_SUCCEEDED';
export const GENERATE_COUPON_REQUESTED = 'GENERATE_COUPON_REQUESTED';
export const GENERATE_COUPON_SUCCEEDED = 'GENERATE_COUPON_SUCCEEDED';
